import { inject } from 'mobx-react';
import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';
import { LocalizedComponentProps, withLocalization } from 'bernie-l10n';
import { ViewLarge, ViewMedium, Viewport, ViewSmall } from 'bernie-view';

import { DisplayAd } from 'constants/ads';
import { ExtendedContextStore } from 'types/flex-definitions';
import { PageName } from 'constants/pages';

import { MesoDisplayAd } from './meso-display-ad';
import { MesoTrigger } from './meso-trigger';
import { SwxlFooter } from 'components/common/footer/swxl-footer';

interface MesoFooterProps {
  destination: string;
  pageName: string;
  isDateless: boolean;
  context?: ExtendedContextStore;
}

@withLocalization
@inject('context')
export class MesoFooter extends React.Component<MesoFooterProps & LocalizedComponentProps> {
  public render() {
    const { pageName, isDateless, context } = this.props;

    return pageName === PageName.SEARCH ||
      pageName === PageName.SEARCH_PACKAGE_HC ||
      pageName === PageName.SEARCH_PACKAGE_FH ||
      pageName === PageName.SEARCH_PACKAGE_FHC ? (
      <HSRFooter context={context} />
    ) : (
      <HISFooter isDateless={isDateless} context={context} />
    );
  }
}

interface FooterProps {
  isDateless?: boolean;
  context?: ExtendedContextStore;
}

const HSRFooter: React.FunctionComponent<FooterProps> = () => (
  <ErrorBoundary label="meso.footer">
    <div className="uitk-grid all-grid-align-center all-t-padding-six">
      <section className="uitk-grid all-grid-align-center">
        <MesoDisplayAd {...DisplayAd.FOOTER_CM1} />
        <MesoDisplayAd {...DisplayAd.FOOTER_CM2} />
        <MesoDisplayAd {...DisplayAd.FOOTER_CM3} />
      </section>
    </div>
    <MesoTrigger pageName={PageName.SEARCH} />
  </ErrorBoundary>
);

const HISFooter: React.FunctionComponent<FooterProps> = ({ isDateless, context }) => (
  <ErrorBoundary label="meso.footer">
    <div className="uitk-grid all-grid-align-center all-y-padding-four all-cell-1-1">
      <div className="uitk-cell all-cell-1-1 all-b-padding-four">
        <section className="uitk-grid all-grid-align-center">
          <MesoDisplayAd {...DisplayAd.FOOTER_CM1} />
          <MesoDisplayAd {...DisplayAd.FOOTER_CM2} />
          <MesoDisplayAd {...DisplayAd.FOOTER_CM3} />
          <MesoDisplayAd {...DisplayAd.FOOTER_CM6} />
        </section>
      </div>
      {isDateless && <HISSwxlFooter context={context} />}
    </div>
    <MesoTrigger pageName={PageName.INFOSITE} />
  </ErrorBoundary>
);

const HISSwxlFooter: React.FunctionComponent<FooterProps> = ({ context }) => (
  <Viewport>
    <ViewSmall>
      <div className="uitk-flex uitk-flex-grow-1 uitk-grid all-grid-align-center all-y-padding-four all-x-padding-four">
        <SwxlFooter context={context} className="uitk-cell all-cell-1-1 all-b-padding-four swxl" />
      </div>
    </ViewSmall>
    <ViewMedium>
      <div className="uitk-flex uitk-flex-grow-1 uitk-grid all-grid-align-center all-y-padding-four">
        <SwxlFooter context={context} className="uitk-cell all-cell-1-1 all-b-padding-four swxl" />
      </div>
    </ViewMedium>
    <ViewLarge>
      <div className="uitk-flex uitk-flex-grow-1 uitk-grid all-grid-align-center all-y-padding-four">
        <SwxlFooter context={context} className="uitk-cell all-cell-1-1 all-b-padding-four swxl" />
      </div>
    </ViewLarge>
  </Viewport>
);
